export default "__VITE_ASSET__DhJFK11___"